module.exports = __webpack_public_path__ + "img/card_meridalighting_background.564a0100.png";